import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
const STORAGE_KEY = "itr-agent-trading-mode";
const TradingModeContext = createContext(null);
function readInitialMode() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw === "sandbox" || raw === "live")
            return raw;
    }
    catch {
        /* ignore */
    }
    return "sandbox";
}
export const TradingModeProvider = ({ children }) => {
    const [mode, setModeState] = useState(readInitialMode);
    const setMode = useCallback((next) => {
        setModeState(next);
        try {
            localStorage.setItem(STORAGE_KEY, next);
        }
        catch {
            /* ignore */
        }
    }, []);
    const value = useMemo(() => ({ mode, setMode }), [mode, setMode]);
    return _jsx(TradingModeContext.Provider, { value: value, children: children });
};
export const useTradingMode = () => {
    const ctx = useContext(TradingModeContext);
    if (!ctx)
        throw new Error("useTradingMode must be used inside TradingModeProvider");
    return ctx;
};
